import { error, json } from "@sveltejs/kit";
import { promises } from "fs";
import path from "path";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
function validatePath(requestPath) {
  const normalized = path.normalize(path.join(WORKSPACE_DIR, requestPath));
  if (!normalized.startsWith(WORKSPACE_DIR)) {
    throw error(403, "Access denied: Path outside workspace directory");
  }
  return normalized;
}
const POST = async ({ request }) => {
  try {
    const { path: filePath, type = "file", content = "" } = await request.json();
    if (!filePath) {
      throw error(400, "Path is required");
    }
    const fullPath = validatePath(filePath);
    try {
      await promises.access(fullPath);
      throw error(409, `${type === "directory" ? "Directory" : "File"} already exists`);
    } catch (err) {
      if (err.code !== "ENOENT") {
        throw err;
      }
    }
    if (type === "directory") {
      await promises.mkdir(fullPath, { recursive: true });
    } else {
      const dir = path.dirname(fullPath);
      await promises.mkdir(dir, { recursive: true });
      await promises.writeFile(fullPath, content, "utf-8");
    }
    return json({
      success: true,
      path: filePath,
      type
    });
  } catch (err) {
    if (err instanceof Response) throw err;
    console.error("Error creating file/directory:", err);
    throw error(500, "Failed to create file/directory");
  }
};
export {
  POST
};
